'use strict';
/**
 * Only for Forms integrated via Marketo embed code*
 * Mostly for Events website*
 */

const unstyleMktoForm = (mktoForm, moreStyles) => {
    let formEl = mktoForm.getFormElem()[0],
        arrayFrom = Function.prototype.call.bind(Array.prototype.slice);

    // remove element styles from <form> and children
    let styledEls = arrayFrom(formEl.querySelectorAll("[style]")).concat(formEl);
    styledEls.forEach(function(el) {
        el.removeAttribute("style");
    });

    // disable remote stylesheets and local <styles>
    let styleSheets = arrayFrom(document.styleSheets);
    styleSheets.forEach(function(ss) {
        if ( [mktoForms2BaseStyle,mktoForms2ThemeStyle].indexOf(ss.ownerNode) != -1 || formEl.contains(ss.ownerNode) ) {
            ss.disabled = true;
        }
    });

    if(!moreStyles) {
        formEl.setAttribute("data-styles-ready", "true");
    }

    $(formEl).velocity("fadeIn", {display: "block"}, { duration: 1500 });
};

const checkLoadedForm = () => {

    const checkLoadedFormInterval = setInterval(() => {

        if($('.mktoForm').length){

            clearInterval(checkLoadedFormInterval);

            MktoForms2.whenRendered(function (form) {

                $(".mktoForm .mktoField").addClass("browser-default");

                unstyleMktoForm(form);

                //onSuccess
                form.onSuccess(function(values, followUpUrl){
                    form.getFormElem().fadeOut('200',function(){
                        $('.confirmation-form').velocity("fadeIn", {display: "block"}, { duration: 1500 });
                    });

                    //return false to prevent the submission handler from taking the lead to the follow up url
                    return false;
                });
            });
        }

    }, 500);

};

const initMarketoEmbedForms = () => {
    const checkMktoLib = setInterval(() => {
        if (typeof MktoForms2 !== "undefined") {
            clearInterval(checkMktoLib);
            checkLoadedForm();
        }
    },200);
};

export default initMarketoEmbedForms;